import { createFileRoute } from '@tanstack/react-router'

import { GenericProblemMessage } from '../../../../components/organisms/generic-problem-message.tsx'
import { OrganizationMembersPage } from '../../../../components/pages/backoffice/partners/settings/members-page.tsx'
import { InviteToLoginPage } from '../../../../components/templates/invite-to-login/invite-to-login-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'
import { useBackofficeUser } from '../../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/settings/members/')({
  component: function Component() {
    const backofficeUser = useBackofficeUser()
    if (!backofficeUser) return <InviteToLoginPage />
    if (backofficeUser.type !== 'partner') {
      return (
        <GenericProblemMessage
          title="Pas encore disponible"
          principalMessage="Cette page n'est pas encore disponible pour les utilisateurs du BO"
          firstSubText="Vous devez être un broker pour accéder à cette page"
          secondSubText="Si vous êtes un broker, contactez-nous"
          onButtonClick={() => {
            history.go(-1)
          }}
          buttonText="Revenir à la page précédente"
        />
      )
    }
    return (
      <PermissionChecker requiredPermissions={['membership.edit']}>
        <OrganizationMembersPage />
      </PermissionChecker>
    )
  },
})
